import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    minWidth: 0
  },
  heading: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  picker: {
    maxWidth: '420px'
  },
  // Pinned to the top of the open list, over the setups scrolling under it, so it needs a solid background.
  makeOwn: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: palette.shades[100],
    borderBottom: "1px solid ".concat(palette.shades[400]),
    color: palette.primary.dark,
    fontWeight: 600,
    '&:hover, &.Mui-focusVisible': {
      backgroundColor: palette.shades[250]
    }
  },
  summary: {
    border: "1px solid ".concat(palette.shades[400]),
    borderRadius: '8px',
    padding: '4px 16px 12px'
  },
  // The PRD mockup's rows: a fixed label column, the value beside it, one column on a narrow screen.
  row: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 12rem) minmax(0, 1fr)',
    gap: '4px 12px',
    alignItems: 'center',
    padding: '8px 0',
    // The intake address and the portal account belong to the row above them, so the line goes under them.
    '& + &, $intake + &, $portal + &': {
      borderTop: "1px solid ".concat(palette.shades[400])
    },
    '@media (max-width: 520px)': {
      gridTemplateColumns: 'minmax(0, 1fr)'
    }
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    fontWeight: 600
  },
  value: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '6px',
    minWidth: 0,
    overflowWrap: 'anywhere'
  },
  needs: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px'
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '8px',
    marginTop: '8px'
  },
  pending: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '4px 8px',
    padding: '8px 0'
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  // The setup editor (LB-6189).
  editor: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    minWidth: 0
  },
  editorGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    minWidth: 0
  },
  // The source cards: two to a row, one on a narrow screen.
  cards: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '8px',
    '@media (max-width: 600px)': {
      gridTemplateColumns: 'minmax(0, 1fr)'
    }
  },
  card: {
    margin: 0,
    // A label sizes to its text: fill the grid cell, so the cards line up.
    width: '100%',
    boxSizing: 'border-box',
    alignItems: 'flex-start',
    border: "1px solid ".concat(palette.shades[400]),
    borderRadius: '8px',
    padding: '8px 12px 8px 4px',
    minWidth: 0,
    '& .MuiRadio-root': {
      paddingTop: '2px'
    }
  },
  cardSelected: {
    borderColor: palette.primary.main,
    boxShadow: "inset 0 0 0 1px ".concat(palette.primary.main)
  },
  cardText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    minWidth: 0,
    overflowWrap: 'anywhere'
  },
  cardTitle: {
    fontWeight: 600
  },
  soon: {
    marginLeft: '6px',
    fontSize: '12px',
    fontWeight: 600,
    color: palette.shades[700]
  },
  twin: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '12px',
    '@media (max-width: 600px)': {
      gridTemplateColumns: 'minmax(0, 1fr)'
    }
  },
  grow: {
    flex: '1 1 auto',
    minWidth: 0
  },
  impact: {
    border: "1px solid ".concat(palette.shades[400]),
    borderRadius: '8px',
    padding: '8px 12px',
    backgroundColor: palette.shades[100]
  },
  // The company's intake address (LB-6190): under the summary's first row, or boxed under the editor's source cards.
  intake: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    minWidth: 0,
    paddingBottom: '8px'
  },
  // This utility's portal login (LB-6191): under the summary's first row, or under a link refused for want of one.
  portal: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    minWidth: 0,
    paddingBottom: '8px'
  },
  intakeBox: {
    border: "1px solid ".concat(palette.shades[400]),
    borderRadius: '8px',
    padding: '8px 12px'
  },
  intakeLabel: {
    fontWeight: 600
  },
  intakeRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '4px 8px',
    minWidth: 0
  },
  // Selected whole with one click, and broken anywhere a long address has to.
  intakeAddress: {
    fontFamily: 'monospace',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    padding: '4px 8px',
    borderRadius: '4px',
    border: "1px solid ".concat(palette.shades[400]),
    backgroundColor: palette.shades[100],
    userSelect: 'all',
    overflowWrap: 'anywhere',
    minWidth: 0
  }
});
export default useStyles;